import { render } from "./PayProvider.vue?vue&type=template&id=980f457a&scoped=true"
import script from "./PayProvider.vue?vue&type=script&lang=js"
export * from "./PayProvider.vue?vue&type=script&lang=js"

import "./PayProvider.vue?vue&type=style&index=0&id=980f457a&scoped=true&lang=css"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980f457a"]])

export default __exports__